import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "@/i18n";

const SRC_ORDER = ["/gallery-1.jpg", "/gallery-2.jpg", "/gallery-4.jpg", "/gallery-3.jpg", "/gallery-5.jpg"];
const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-4", "md:col-span-4", "md:col-span-4"];
const HEIGHTS = ["h-64 md:h-[26rem]", "h-64 md:h-[26rem]", "h-56 md:h-72", "h-56 md:h-72", "h-56 md:h-72"];

export default function Gallery() {
    const { t } = useLang();

    return (
        <section id="gallery" className="relative py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-5 md:px-8">
                <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
                    <Reveal>
                        <Eyebrow>{t.gallery.eyebrow}</Eyebrow>
                        <h2 className="mt-4 max-w-2xl font-display text-4xl font-semibold leading-[1.08] tracking-tight text-brand-navy md:text-5xl lg:text-6xl">
                            {t.gallery.h2a} <em className="italic text-brand-olive">{t.gallery.h2b}</em>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <p className="max-w-xs text-sm leading-relaxed text-slate-500 md:text-right">{t.gallery.note}</p>
                    </Reveal>
                </div>

                <div data-testid="gallery-section" className="grid grid-cols-1 gap-5 md:grid-cols-12 md:gap-6">
                    {SRC_ORDER.map((src, i) => (
                        <Reveal key={src} delay={0.08 + i * 0.07} className={SPANS[i]}>
                            <figure
                                data-testid={`gallery-item-${i + 1}`}
                                className={`group relative overflow-hidden rounded-3xl border border-slate-200 shadow-card ${HEIGHTS[i]}`}
                            >
                                <img
                                    src={src}
                                    alt={`${t.gallery.captions[i]} — Signita Wellness`}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 bg-gradient-to-t from-brand-navy/80 via-brand-navy/30 to-transparent p-5 pt-12">
                                    <figcaption className="text-xs font-semibold text-white md:text-sm">
                                        {t.gallery.captions[i]}
                                    </figcaption>
                                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/60">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
